import script from "./CobroFacturaVentaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CobroFacturaVentaView.vue?vue&type=script&setup=true&lang=js"

import "./CobroFacturaVentaView.vue?vue&type=style&index=0&id=73398976&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73398976"]])

export default __exports__